import {SynchroType} from "@/domain/type/synchro.type.ts";
import ProductConfig from "@/application/typeConfig/ProductConfig.ts";
import PersonConfig from "@/application/typeConfig/PersonConfig.ts";
import CompanyConfig from "@/application/typeConfig/CompanyConfig.ts";
import CourseConfig from "@/application/typeConfig/CourseConfig.ts";
import LocationConfig from "@/application/typeConfig/LocationConfig.ts";
import SessionConfig from "@/application/typeConfig/SessionConfig.ts";
import type AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";

export function getConfigByType(type: string): null | AbstractType {
  switch (type) {
    case SynchroType.COMPANIES:
      return new CompanyConfig()
    case SynchroType.PRODUCT:
      return new ProductConfig()
    case SynchroType.PERSONS:
      return new PersonConfig()
    case SynchroType.COURSE:
      return new CourseConfig()
    case SynchroType.LOCATION:
      return new LocationConfig()
    case SynchroType.SESSIONS:
      return new SessionConfig()
    default:
      return null;
  }
}
